import { TranslatedString } from "./translated-string"

export interface Container {
    id: string
    containerItemSchema: {
        name: TranslatedString
        openContainer: boolean
    },
    locationItemSchema?: {
        realTimeLocation?: string,
        permanentLocation?: string,
    }
    type: string
}

export enum ContainerStatus {
    OPEN = 'true',
    CLOSED = 'false',
    NOT_DEFINED = 'is-missing',
}